export enum UserAuthScopeTypeEnum {
  PUBLIC = 'public',
  PRIVATE = 'private',
}
